import * as React from 'react';
import { useTranslation } from 'react-i18next';

import Appartement from '@hvcgroep/design-system/assets/illustrations/Appartement.svg';
import Hoekwoning from '@hvcgroep/design-system/assets/illustrations/Hoekwoning.svg';
import TweeOnderEenKap from '@hvcgroep/design-system/assets/illustrations/Twee-onder-een-kap.svg';
import Tussenwoning from '@hvcgroep/design-system/assets/illustrations/Tussenwoning.svg';
import Vrijstaand from '@hvcgroep/design-system/assets/illustrations/Vrijstaand.svg';

import {
  NIBUD_FLAT,
  NIBUD_2_ONDER_1_KAP,
  NIBUD_HOEKWONING,
  NIBUD_TUSSENWONING,
  NIBUD_VRIJSTAAND,
} from '../../config/constants';
import { NibudType } from '../../types/orchestrator';

interface Props extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  nibudType: NibudType
}

const NibudIcon: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const { nibudType, ...rest } = props;

  switch (nibudType) {
    case NIBUD_FLAT:
      return <img src={Appartement} alt={t(`registration_desk.nibud_icon.alt_texts.${NIBUD_FLAT}`)} {...rest} />;

    case NIBUD_2_ONDER_1_KAP:
      return <img src={TweeOnderEenKap} alt={t(`registration_desk.nibud_icon.alt_texts.${NIBUD_2_ONDER_1_KAP}`)} {...rest} />;

    case NIBUD_HOEKWONING:
      return <img src={Hoekwoning} alt={t(`registration_desk.nibud_icon.alt_texts.${NIBUD_HOEKWONING}`)} {...rest} />;

    case NIBUD_TUSSENWONING:
      return <img src={Tussenwoning} alt={t(`registration_desk.nibud_icon.alt_texts.${NIBUD_TUSSENWONING}`)} {...rest} />;

    case NIBUD_VRIJSTAAND:
      return <img src={Vrijstaand} alt={t(`registration_desk.nibud_icon.alt_texts.${NIBUD_VRIJSTAAND}`)} {...rest} />;

    default:
      return <div>{t('waste_icon.not_found', { nibudType })}</div>;
  }
};

export default NibudIcon;
